<template>
    <div>
        cerrar sesion
    </div>
</template>
<script>
    export default {
      created () {
          localStorage.setItem('iduser',0);
              localStorage.setItem('username', '');
              localStorage.setItem('permission',0);
        this.$router.push('/')
      }
    }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/cerrarSesion/cerrarSesion.vue